import dayjs from "dayjs";
import { RentPeriodSchemaModel } from "../types/RentPeriodSchemaModel";
import { RentalPeriodModel } from "../components/RentalPeriodSelector/types";

export function useRentalPeriodFormatter() {
  /**
   * Utility function to convert a `RentalPeriodModel` to `RentPeriodSchemaModel`.
   * @param {RentalPeriodModel} rentPeriod - The rental period in model form.
   * @returns {RentPeriodSchemaModel} - The rental period in rent period form.
   */
  function rentalPeriodModelToSchemaModel(
    rentPeriod: RentalPeriodModel,
  ): RentPeriodSchemaModel {
    return {
      rentalStartDate: dayjs(rentPeriod.from).format("YYYY-MM-DD"),
      rentalDays: dayjs(rentPeriod.to).diff(rentPeriod.from, "days"),
    };
  }

  /**
   * Utility function to convert a `RentPeriodSchemaModel` to `RentalPeriodModel`.
   * @param {RentPeriodSchemaModel} rentPeriodSchemaModel - The rental period in cart rent period form.
   * @returns {RentalPeriodModel} - The rental period in model form.
   */
  function rentalSchemaModelToRentPeriodModel(
    rentPeriodSchemaModel: RentPeriodSchemaModel,
  ): RentalPeriodModel {
    const startRentDate = dayjs(
      rentPeriodSchemaModel.rentalStartDate,
      "YYYY-MM-DD",
    ).startOf("day");
    return {
      from: startRentDate.toDate(),
      to: startRentDate
        .clone()
        .add(rentPeriodSchemaModel.rentalDays, "days")
        .toDate(),
    };
  }

  /**
   * Utility function to get the number of days for a given `RentPeriod`.
   * @param {RentalPeriodModel} rentPeriod - The rental period.
   * @returns {number} - Number of days in the rental period.
   */
  function rentalPeriodDays(rentPeriod: RentalPeriodModel): number {
    return dayjs(rentPeriod.to).diff(rentPeriod.from, "days");
  }

  return {
    rentalPeriodModelToSchemaModel,
    rentalSchemaModelToRentPeriodModel,
    rentalPeriodDays,
  };
}
